// Canonical benefits checklist used everywhere an employer selects benefits
// (Company Profile, Post/Edit Job, Send Job Offer) so wording matches exactly
// and pre-fill matching between them (e.g. employer.typical_benefits -> job
// posting benefits) works via plain string equality.
export const BENEFIT_OPTIONS = [
  'Health insurance',
  'Dental insurance',
  'Vision insurance',
  '401(k)',
  'Paid time off',
  'Life insurance',
  'Tuition reimbursement',
  'Tool allowance',
  'Overtime available',
];
